import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
// ReportOnce "default" theme logo.
import roLogo from "../images/reportonce-logo-white.svg";
// Nelson Alexander theme logo.
import naLogo from "../images/na-logo.svg";
// Barry Plant theme logo.
import bpLogo from "../images/bp-logo.svg";
// Highland theme logo.
import hcLogo from "../images/highland-logo.svg";
// RT Edgar Logo
import rtLogo from "../images/rte.fddc0643.svg";
// MW Logo
import mwLogo from "../images/MW_Logo_horizontal_navy.svg"

let typography = {
    h3: {
        fontFamily: "filson-soft, sans-serif",
        fontWeight: 400,
        lineHeight: 1.5,
        fontSize: "32px",
        fontStyle: "normal",
        color: "#5A5A5A",
    },
    h4: {
        fontFamily: "filson-soft,sans-serif",
        fontWeight: 150,
        lineHeight: 1,
        fontSize: "26px",
        fontStyle: "normal",
        color: "#5A5A5A",
    },
    body1: {
        fontSize: "18px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        fontWeight: 400,
        fontStyle: "normal",
    },
    body2: {
        fontSize: "18px",
        fontFamily: "filson-soft,sans-serif",
        color: "#5A5A5A",
        fontWeight: 600,
        fontStyle: "normal",
    },
    subtitle1: {
        fontSize: "16px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        lineHeight: 1.3,
        fontWeight: 350,
        fontStyle: "normal",
    },
    subtitle2: {
        fontSize: "16px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        lineHeight: 2.5,
        paddingBottom: "0.7rem",
        fontWeight: 500,
        fontStyle: "normal",
    },
    caption: {
        fontSize: "11px",
        fontFamily: "filson-soft,sans-serif",
        color: "#AAAAAA",
        fontWeight: 300,
        fontStyle: "normal",
    }
}

// ReportOnce "default" theme settings.
let ro = createMuiTheme({
    palette: {
        primary: {
            // Used for buttons, icons, etc.
            // light: will be calculated from palette.primary.main,
            main: "#8ABB2A",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            // Used for header menu background.
            // light: '#0066ff',
            main: "#384248",
            // dark: will be calculated from palette.secondary.main,
            // contrastText: '#ffcc00',
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
    typography: typography,
});

// Nelson Alexander theme settings.
let na = createMuiTheme({
    palette: {
        primary: {
            // Used for buttons, icons, etc.
            // light: will be calculated from palette.primary.main,
            main: "#FF3223",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            // Used for header menu background.
            // light: '#0066ff',
            main: "#1E0F14",
            // dark: will be calculated from palette.secondary.main,
            // contrastText: '#ffcc00',
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
    typography: typography
});

// Barry Plant theme settings.
let bp = createMuiTheme({
    palette: {
        primary: {
            // Used for buttons, icons, etc.
            // light: will be calculated from palette.primary.main,
            main: "#041c2c",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            // Used for header menu background.
            // light: '#0066ff',
            main: "#ffffff",
            // dark: will be calculated from palette.secondary.main,
            // contrastText: '#ffcc00',
        },
        background: {
            default: "#ecf0f3",
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
    typography: typography,
});

// Harcourts theme settings.
let hc = createMuiTheme({
    palette: {
        primary: {
            // Used for buttons, icons, etc.
            // light: will be calculated from palette.primary.main,
            main: "#00adef",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            // Used for header menu background.
            // light: '#0066ff',
            main: "#002037",
            // dark: will be calculated from palette.secondary.main,
            // contrastText: '#ffcc00',
        },
        background: {
            default: "#f7f7f7",
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
    typography: typography,
});

// RT Edgar theme
let rt = createMuiTheme({
    palette: {
        primary: {
            main: "#02203B",
        },
        secondary: {
            main: "#ffffff",
        },
        contrastThreshold: 3,
        tonalOffset: 0.2,
    },
    typography: typography
});

// Marshall White theme
let mw = createMuiTheme({
    palette: {
        primary: {
            main: "#0D1D34",
        },
        secondary: {
            main: "#ffffff",
        },
        contrastThreshold: 3,
        tonalOffset: 0.2,
    },
    typography: typography
});

const getTheme = (domain = "default") => {
    const themes = {
        ro: { theme: responsiveFontSizes(ro), logo: roLogo },
        na: { theme: responsiveFontSizes(na), logo: naLogo },
        bp: { theme: responsiveFontSizes(bp), logo: bpLogo },
        hc: { theme: responsiveFontSizes(hc), logo: hcLogo },
        rt: { theme: responsiveFontSizes(rt), logo: rtLogo },
        mw: { theme: responsiveFontSizes(mw), logo: mwLogo }
    };

    // Check that domain isn't something we should show a custom theme for.
    if (domain === 'default') {
        return themes["ro"]; // Return 'ro' the default ReportOnce theme.
    }

    return themes[domain]; // We have a custom domain value which has a corresponding theme, so use that.
};

export default getTheme;
